// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Br1eBiimaFKR1BLcEl4J {
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 4px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.15);
}

.Br1eBiimaFKR1BLcEl4J:last-child {
  margin-bottom: 0;
}

.qMb3xfPbW5V7audWyC3X {
  border-color: rgba(42, 109, 244, 0.75);
  box-shadow: 0 0 0 1px rgba(42, 109, 244, 0.35);
}

.oUAD2P0qVylez9Z_EqzG {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  list-style: none;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 600;
  color: rgba(251, 252, 246, 0.92);
  line-height: 1.3;
}

.oUAD2P0qVylez9Z_EqzG::-webkit-details-marker {
  display: none;
}

.iiJ_SoBmKB_vY_ECGBa0 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.MMvrwlHaMygKqyKe944w {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.r4XHhBCaZ2ucoF56Ym_k {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: rgba(251, 252, 246, 0.92);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.NMjnwuMeY16i61gyhW3w {
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.55);
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 2px 6px;
  line-height: 1.2;
}

.fkXjP7gfjDOUIsa0gmrL {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 6px 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/paletteAccordion/PaletteAccordion.module.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,+CAA+C;AACjD","sourcesContent":[".details {\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 4px;\n  margin-bottom: 8px;\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.details:last-child {\n  margin-bottom: 0;\n}\n\n.detailsSelected {\n  border-color: rgba(42, 109, 244, 0.75);\n  box-shadow: 0 0 0 1px rgba(42, 109, 244, 0.35);\n}\n\n.summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n  cursor: pointer;\n  list-style: none;\n  padding: 8px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: rgba(251, 252, 246, 0.92);\n  line-height: 1.3;\n}\n\n.summary::-webkit-details-marker {\n  display: none;\n}\n\n.summaryRow {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n}\n\n.summaryTitleCluster {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.summaryTitle {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  color: rgba(251, 252, 246, 0.92);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.summaryCount {\n  flex-shrink: 0;\n  font-size: 9px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.55);\n  background-color: rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  padding: 2px 6px;\n  line-height: 1.2;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 4px 6px 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": `Br1eBiimaFKR1BLcEl4J`,
	"detailsSelected": `qMb3xfPbW5V7audWyC3X`,
	"summary": `oUAD2P0qVylez9Z_EqzG`,
	"summaryRow": `iiJ_SoBmKB_vY_ECGBa0`,
	"summaryTitleCluster": `MMvrwlHaMygKqyKe944w`,
	"summaryTitle": `r4XHhBCaZ2ucoF56Ym_k`,
	"summaryCount": `NMjnwuMeY16i61gyhW3w`,
	"body": `fkXjP7gfjDOUIsa0gmrL`
};
export default ___CSS_LOADER_EXPORT___;
